import type { ListBoxSectionProps as AriaListBoxSectionProps } from "react-aria-components";
import { Collection, Header, ListBoxSection } from "react-aria-components";

import type { BaseItem } from "@/core/types";
import { cn } from "@/lib/helpers/cn";

type ListBoxSectionProps<T> = {
  children: (item: T) => React.ReactNode;
  header: string;
  items: Iterable<T>;
} & Omit<AriaListBoxSectionProps<T>, "children">;

export function ListBoxSection2<T extends BaseItem>({
  children,
  className,
  header,
  items,
  ...props
}: ListBoxSectionProps<T>) {
  return (
    <ListBoxSection className={className} {...props}>
      <Header
        className={cn(
          "tw:px-2.5 tw:py-1.5",
          "tw:before:block tw:before:h-px tw:before:bg-fill-quinary",
          "tw:before:mt-2 tw:before:mb-3",
          "tw:[section:first-of-type_&]:before:hidden",
          "body-sm tw:tracking-wide tw:text-text-tertiary!",
          "tw:select-none",
        )}
      >
        {header}
      </Header>
      <Collection items={items}>{children}</Collection>
    </ListBoxSection>
  );
}
